import * as React from 'react';
import { useSelector } from 'react-redux';

import { DiscountMortgageLabel } from 'shared/components/DiscountMortgageLabel/DiscountMortgageLabel';
import { selectHasDiscountMortgage } from 'shared/selectors/mortgage';

export function DiscountMortgageLabelContainer() {
  const hasDiscountMortgage = useSelector(selectHasDiscountMortgage);

  if (!hasDiscountMortgage) {
    return null;
  }

  return <DiscountMortgageLabel />;
}
